/**
 * TK-43 — DẤU SDKD (đèn đường + nút mạng), hình học chép nguyên `brand/app-mark.svg` của bộ icon SDKD v01, đơn sắc `currentColor`
 *   (màu do chỗ đặt quyết định, vd `text-nhan`). Một component cho mọi chỗ làm logo: đầu trang, trang đăng nhập.
 */
export function LogoSdkd({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true" data-o="logo-sdkd">
      <path d="M20 47V24a10 10 0 0 1 10-10h9M12 51h18" stroke="currentColor" strokeWidth="4.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M34 13h15a3 3 0 0 1 3 3v5H34z" fill="currentColor" />
      <path d="M31 36h10v10h10" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="31" cy="36" r="3.2" fill="currentColor" />
      <circle cx="41" cy="46" r="3.2" fill="currentColor" />
      <circle cx="51" cy="46" r="3.2" fill="currentColor" />
    </svg>
  );
}
